<template>
    <div class="profile__main">
        <div class="profile__main__header">
            <h3 class="profile__main__header__title">
                کالاهای لیست اطلاع رسانی موجودی
            </h3>
            <a :href="route('site.profile')" class="btn custom-btn profile__main__header__btn">
                <i class="fa fa-angle-right"></i>&nbsp; بازگشت
            </a>
        </div>
        <div class="profile__main__body">
            <div class="profile__main__account" :class="{loading}">
                <div class="products-list" v-if="data.length">
                    <div class="row gx-2">
                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3" v-for="product in data">
                            <div class="waiting-list_product">
                                <ProductCard :product="product" />
                                <button type="button" @click="remove(product)" class="btn btn-xs btn-sm btn-outline-danger"><i class="fa fa-close"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="width: 100%;" v-else-if="!loading" class="alert alert-info">کالایی در این لیست یافت نشد.</div>
            </div>
        </div>
    </div>
</template>

<script>
import ProductCard from "../product/ProductCard.vue";

export default {
    name: "ProfileDashboard",
    components: {ProductCard},
    data() {
        return {
            loading: false,
            data: [],
        }
    },
    computed: {
        authenticated() {
            console.log('hi');
            return this.isAuthenticated();
        },
    },
    watch: {
        authenticated() {
            this.checkIsLoading();
        }
    },
    methods: {
        async request() {
            this.loading = true;
            const token = this.token();
            const config = {
                headers: { Authorization: `Bearer ${token}` }
            };
            await this.axios.get(this.route('api.profile.waiting-list.index'), config).then(response => {
                this.data = response.data.data;
                this.loading = false;
            });
        },
        async remove(product) {
            this.loading = true;
            const config = {
                headers: {
                    Authorization: 'Bearer '+localStorage.getItem('_token')
                }
            };
            await this.axios.delete(this.route('api.profile.waiting-list.destroy', [product.id]), config)
                .then()
                .catch(error => {
                    this.errorToast(null, error);
                });
            await this.request();
            this.loading = false;
        }
    },
    mounted() {
        this.request();
    }
}
</script>

<style scoped>
.waiting-list_product{
    position: relative;
}
.waiting-list_product > button{
    position: absolute;
    top: 16px;
    left: 16px;
}
</style>
